// removed by extract-text-webpack-plugin
module.exports = {"sales-service__description":"sales-service__description","sales-service__sales-map":"sales-service__sales-map","image":"image"};


//////////////////
// WEBPACK FOOTER
// ../css/components/_sales-service.scss
// module id = 284
// module chunks = 0